import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';

import { getHeaderLinksCopy } from './constants/header-links';
import { GroupedNavigationLinks } from '../../../core/models/grouped-navigation-links';
import { HeaderMobileComponent } from './header-mobile/header-mobile.component';

import { HeaderDropdownComponent } from './header-dropdown/header-dropdown.component';
import { MatMenuService } from '../../../core/services/utilities/menu-hover.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatToolbarModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        HeaderMobileComponent,
        HeaderDropdownComponent,
    ],
})
export class HeaderComponent {
    headerLinks: GroupedNavigationLinks[];

    constructor(private readonly matMenuService: MatMenuService) {
        this.headerLinks = this.formatHeaderTitles(getHeaderLinksCopy());
    }

    mouseEnter(trigger: MatMenuTrigger) {
        this.matMenuService.openMenu(trigger);
    }

    mouseLeave(trigger: MatMenuTrigger) {
        this.matMenuService.closeMenuWithDelay(trigger);
    }

    private formatHeaderTitles(
        headerLinks: GroupedNavigationLinks[],
    ): GroupedNavigationLinks[] {
        headerLinks.forEach((group) => {
            if (group.text.includes(' &')) {
                // If '&' symbol exists, line break before it.
                group.text = group.text.replace(' &', '<br>&');
            } else {
                // If no '&' symbol exists, line break after spaces.
                group.text = group.text.split(' ').join('<br>');
            }
        });

        return headerLinks;
    }
}
